module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/T3YbtY/tc-custom/9781398473027.jpg?1705539731926",
      "alt": "This image is the cover for the book Charles The Great - Charlemagne"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charles The Great - Charlemagne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Charlemagne was perhaps one of the most remarkable of the Kings of France. Born on 7 April 742, his astonishing rise to power has long fascinated historians. The founder of the Carolingian dynasty, he united much of Western Europe under his banner. After he was crowned King of the Franks, he constantly travelled across his lands from Spain to Italy, defending his Realm, but also encouraging education, the building of beautiful public architecture, artwork, and the adoption of Christianity. There was contact with diverse rulers, from the Byzantine empire, the Saracens of Spain, Danish Kings and Kings of Wessex. He had to deal with treachery from within his own family, and dealt with numerous other factions in his reign, subduing the Lombards, Saxons and Avars, sometimes with magnanimity, and other times with severity. He lived to see five Popes of the Roman Catholic Church, and was finally crowned Holy Roman Emperor in 800. He, more than anyone else, made the European 'Dark Ages' light.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pauline Palmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Pauline Palmer is a native of Birmingham and has lived in South Pembrokeshire for thirty years. Her interest in Charlemagne began in the 1980s following a visit to Aachen Cathedral.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0